export default __webpack_public_path__ + "static/media/4.51376033.png";